@if (config.headerComponent['language_sel'] != undefined) {
  @if (speedConfig.data != undefined && speedConfig.data.speedMbps != undefined && speedConfig.data.speedMbps == 0) {
    <div class="speed_offline">Offline</div>
  }
  @if (config.noticeList != undefined && config.noticeList.length > 0) {
    <div class="notice-container message-wrapper {{config.noticeList[0]['priority']}}-msg">
      <div class="message-container">{{config.noticeList[0]['text']}}</div>
      <div class="d-flex-horizontal">
        @if (config.noticeList[0]['readMore'] != undefined) {
          <div class="read-more-link" (click)="readFullNotice()">
            Read more
          </div>
        }
        <div class="close-icon-container" (click)="handleList(true)">
          <i class="fa fa-times-circle" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  }
  <!-- <div class="message-wrapper {{config.noticeList[0]['priority']}}-msg">
    <div class="message-container">Bill Not Paid</div>
    <div class="d-flex-horizontal">
      <div class="read-more-link">
        Read more
      </div>
      <div class="close-icon-container" (click)="handleList(true)">
        <i class="fa fa-times-circle" aria-hidden="true"></i>
      </div>
    </div> -->

  <app-header [navbarBrandRouterLink]="['/'+appService._appData.DEFAULT_APPLICATION+'/dashboard']" [fixed]="true"
    [navbarBrandFull]="{src: headerJson.logo,alt: headerJson.name}"
    [navbarBrandMinimized]="{src: headerJson.logo_small_path, alt: headerJson.name}" [sidebarToggler]="'lg'"
    [asideMenuToggler]="false">
    <!---->
    @if (config.headerComponent.facility_sel && _currentData.org && _currentData.org.org_name != undefined && !appService.isFacilityAware()) {
      <div class="d-none d-lg-block dropdown org-location-selector header-dropdown ml-4 dd-hover">
        <kx-multiselect-dropdown title="Facility Location" tabindex="-1" [settings]="facilitySearchSelect.defaultsetting"
          [questions]="facilitySearchSelect.question" [format]="facilitySearchSelect.question.format" name="facility"
          [placeholder]="_currentData.org.org_name" [data]="facilitySearchSelect.datasource"
          (onSelect)="onItemSelect($event)">
        </kx-multiselect-dropdown>
      </div>
    }
    <!-- <li class="org-link _for-web"
      *ngIf="config.headerComponent.external_website && appService._currentSessionData.accountWebsite  && roleService.checkAccessPermission('web_link','login','account-management')">
      <a target="_blank" href="{{appService._currentSessionData.accountWebsite}}" class="web-link btn-with-icon-label">
        <i aria-hidden="true" class="fa fa-external-link"></i>
        <span class="" *ngIf="!appService._currentSessionData.webSiteName"> Web Link </span>
        <span class=""
          *ngIf="appService._currentSessionData.webSiteName">{{appService._currentSessionData.webSiteName}}</span>
      </a>
    </li> -->
    <!-- Not needed right now -->
    @if (_currentData) {
      <ul class="right-header-section nav navbar-nav ml-auto mr-3">
        <!-- for patient uhid name -->
        @if (this._currentData.currentUser && this._currentData.currentUser['user_type'] == 'patient' && !checkKioskUser()) {
          <div class="family-group-container d-flex align-items-center mr-2">
            <li class="cursor-pointer patient-name-container">
              <strong
                (click)="this._currentData.firstTimeLogin ? '': showFamilyMember($event);">{{_currentData.loggedInUserName
                }}<br /> {{ baseService.buildDyanamicStr("!!!uhId!!!",{})}}
              </strong>
            </li>
            @if (this._currentData.currentUser && this._currentData.currentUser['user_type'] == 'patient' && !checkKioskUser()) {
              <li class="_family-member-dropdown"
                (click)="this._currentData.firstTimeLogin ? '': showFamilyMember($event);">
                <!-- <fa class="fa fa-angle-down"></fa> -->
                <i><img src="assets/images/icons/family-icon.svg" alt="" width="35px" height="35px"></i>
              </li>
            }
          </div>
        }
        @if (_currentData.currentRole['role'] != 'payment') {
          @if (config.showFamilyMember) {
            <li class="role-container _header-item">
              <div class="dropdown header-dropdown dd-hover" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false" (clickOutside)="closeDropdownEvents()">
                <div class="_menu-dropdown dropdown-menu dropdown-menu-right dropdown-menu-sm" id="role-dropdown"
                  style="top: 20px;display:block;">
                  @if (config.showFamilyMember) {
                    <kx-select-profile-extended></kx-select-profile-extended>
                  }
                </div>
              </div>

            </li>
          }
          <!-- for patient uhid name -->
          <!-- {{getCareTypeConfig() | json}} -->
          @if (config.headerComponent.care_type && _getmultiOpdConfig('multi_care_type') && _getmultiOpdConfig('care_type').length != 0 && currentResourecValue$ && !utilService.isMobile()) {
            <li class="_header-item">
              <!--for opd type dropdown-->
              <app-opd-type-selection [care_type]="_getmultiOpdConfig('care_type')" [checkDisabled]="checkResourceDisbled$"
                (opdType)="changeopdType($event)">
              </app-opd-type-selection>
            </li>
          }
          <li>
            <!--for location dropdown-->
            @if (config.headerComponent.location_sel && storeAllowed) {
              <ng-container [ngTemplateOutlet]="locationRendrer"
                [ngTemplateOutletContext]="{appService:appService}">
              </ng-container>
            }
          </li>
          @if (config.headerComponent.language_sel && appService._currentSessionData && appService._currentSessionData.languageList && appService._currentSessionData.languageList.length != 1) {
            <li title="Language" class="language-selector _header-item">
              <div class="dropdown-left  dd-hover">
                <div class="organization-dropdown">
                  <dhs-langugage-selection [languageList]="appService._currentSessionData.languageList"
                    (languageVal)="languageChange($event)"></dhs-langugage-selection>
                </div>
              </div>
            </li>
          }


          @if (config.headerComponent.ai_agent_dashboard ) {
            <li class="org-link _for-web">
              <a [title]="'link.ai_agent_dashboard'| translate | async" (click)="naviagteToLink('/emr/ai-agent-dashboards')"
                class="web-link btn-with-icon-label">
                <i aria-hidden="true" class="notification-icon-container ai-icon-container"><img src="/assets/images/ai-icon-star.svg" alt=""
                    width="27px" height="27px"></i>
              </a>
            </li>
          }
          @if (config.headerComponent.qms_sel && roleService.checkAccessPermission('view_qms', 'queue_desk', 'queue-management')) {
            <li title="Queue Management System" class="qms-token _header-item">
              <!-- <img src="assets/images/token/token.svg" alt="token" [popover]="tokenRendrer" containerClass="tokenKeyContainer"
            placement="bottom" [outsideClick]="true"> -->
              @if (!isTokenPopoverOpen) {
                <div class="qms-token-button _ha-icon" (click)="toggleTokenPopover($event)">
                  <!-- QMS
                  <i aria-hidden="true" class="fa fa-angle-down loc_down_arrow pl-2"></i> -->
                  <img src="assets/images/icons/QMS-Mobile.svg" alt="" width="25px" height="25px">
                </div>
              } @else if (isTokenPopoverOpen) {
                <div class="qms-token-button"
                [popover]="tokenRendrer"
                containerClass="tokenKeyContainer"
                placement="bottom"
                [outsideClick]="true"
                [isOpen]="true"
                (onHidden)="isTokenPopoverOpen = false"
                (click)="keepTokenPopoverOpen($event)">
                  <!-- QMS
                  <i aria-hidden="true" class="fa fa-angle-down loc_down_arrow pl-2"></i> -->
                  <img src="assets/images/icons/QMS-Mobile.svg" alt="" width="25px" height="25px">
                </div>
              }
            </li>
          }
          <!-- web icon-->


          @if (appService._currentSessionData.showAccountWebsite && config.headerComponent.external_website && appService._currentSessionData.accountWebsite && roleService.checkAccessPermission('web_link','login','account-management')) {
            <li class="org-link _for-web">
              <a title="{{appService._currentSessionData.accountWebsiteLabel}}" (click)="openWebsite()"
                class="web-link btn-with-icon-label">
                <i aria-hidden="true" class="notification-icon-container _ha-icon"><img src="assets/images/icons/web-link.svg" alt=""
                    width="25px" height="25px"></i>
                <!-- <span class="" *ngIf="!appService._currentSessionData.webSiteName"> Web Link </span>
            <span class=""
              *ngIf="appService._currentSessionData.webSiteName">{{appService._currentSessionData.webSiteName}}</span> -->
              </a>
            </li>
          }

          @if (!utilService.isMobile() && !checkKioskUser()) {
            <li title="Enable/Disable Voice Input" class="_header-item">
              <!-- <kx-voice-search></kx-voice-search> -->
              <div class="_voice-icon _ha-icon" [ngClass]="preferenceService.checkCommonConfigEnabled('voice_search')?'active':''">
                <i class="fa fa-microphone" aria-hidden="true" (click)="changeVoiceEnable(false)"></i>
                <i class="fa fa-microphone-slash" aria-hidden="true" (click)="changeVoiceEnable(true)"></i>
              </div>
            </li>
          }

          @if (isPatientHelpDocumentAvailable) {
            <li title="Help Document" class="_header-item"
              (click)="openHelpDocument()">
              <div class="_help-icon">
                <i class="fa fa-question-circle" aria-hidden="true"></i>
              </div>
            </li>
          }

          <!-- Helpdesk Ticket -->
          @if (config.headerComponent.helpdesk_sel && (this._currentData.currentUser && this._currentData.currentUser['user_type'] != 'patient' && this._currentData.currentUser['user_type'] != 'system_user')) {
            <li title="{{'Helpdesk Ticket' | translate | async }}"
              class="_header-item profileMenu show" #helpdeskMenuRef
              (click)="checkHelpDocumentAvailability()">
              <a [triggered]="config.helpdeskTicket"
                (clickOutside)="closeDropdownEvents()">
                <div _ngcontent-nyk-c113="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                  class="dropdown pl-2 pr-2 notification-icon-container dd-hover _ha-icon" style="padding: 4px !important;"
                  ng-reflect-triggered="false">
                  <!-- <i class="fa fa-user-headset" aria-hidden="true"></i> -->
                  <img src="assets/images/ticket-call.svg" alt="">
                </div>
              </a>
              <div #helpDeskMenu class="_menu-dropdown profile-menu-dropdown"
                [hidden]="config.helpdeskTicket == undefined || !config.helpdeskTicket">
                <!--Back button for mobile menu-->
                <div class="icons-for-back-cross">
                  <div class="profile-menu-back-icon" (click)="config.helpdeskTicket = false; $event.stopPropagation()">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="profile-menu-container">
                  <div class="profile-menu-middle-section">
                    <div>
                      <a href="helpdeskmgmt/helpdesk_ticket_form/add" class="dropdown-item">{{'Add New Ticket' | translate |
                        async}}</a>
                    </div>
                    <div>
                      <a href="helpdeskmgmt/helpdesk_ticket_manager_format" class="dropdown-item">{{'My Tickets' |translate |
                        async}}</a>
                    </div>
                    <div>
                      <a href="opsmgmt/help-document" class="dropdown-item">{{'help.document' |translate |
                        async}}</a>
                    </div>
                    @if (isHelpDocumentAvailable) {
                      <div>
                        <a class="dropdown-item" (click)="openHelpDocument()">{{'help.doc' | translate |
                          async}}</a>
                      </div>
                    }
                    <div>
                      <a href="release-notes" class="dropdown-item">Release Notes</a>
                    </div>
                    <div>
                      <a href="data-onboarding/training" class="dropdown-item">Knowledge Library</a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          }
          <!-- Heldesk Ticket -->
          @if (appService._currentSessionData.showAccountWebsite && config.headerComponent.external_website && appService._currentSessionData.accountWebsite && roleService.checkAccessPermission('web_link','login','account-management')) {
            <li class="org-link _for-mobile">
              <a title="{{appService._currentSessionData.accountWebsiteLabel}}" (click)="openWebsite()"
                class="web-link btn-with-icon-label">
                <i aria-hidden="true" class="notification-icon-container _ha-icon"><img src="assets/images/icons/web-link.svg" alt=""
                    width="25px" height="25px"></i>
                <!-- <span class="" *ngIf="!appService._currentSessionData.webSiteName"> Web Link </span>
            <span class=""
              *ngIf="appService._currentSessionData.webSiteName">{{appService._currentSessionData.webSiteName}}</span> -->
              </a>
            </li>
          }


          @if (config.headerComponent.noty_sel && checkSystemAdmin() && !checkKioskUser()) {
            <li title="{{'Notifications' | translate | async }}" class="notification-container _header-item ml-1">
              <!-- {{getNotificationCount() | json}} -->
              <!-- <span *ngFor="let s of getNotificationCount()">{{s}}</span> -->
              <div class="dropdown pl-2 pr-2 notification-icon-container dd-hover _ha-icon" [triggered]="showNotification"
                (click)="getNotification(1,true)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                (clickOutside)="closeDropdownEvents()">
                <!-- <span class="notification-badge badge badge-danger" [ngClass]="changeColor?'border-danger':''"
              *ngIf="!count && payload">{{payload.count}}</span> -->
                <!-- <span class="notification-badge badge badge-danger" [ngClass]="changeColor?'border-danger':''"
              *ngIf="count == 0">0</span> -->
                @if (count) {
                  <span class="notification-badge badge badge-danger" [ngClass]="changeColor?'border-danger':''">{{count > 21 ? 20+"+":count}}</span>
                }
                <i class="fa fa-bell" aria-hidden="true" [ngClass]="changeColor?'text-danger':''"></i>
                @if (payload && showNotification) {
                  <span>
                    @if (payload.length > 0) {
                      <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg _menu-dropdown notification-dd"
                        style="top: 40px; display:block">
                        <div class="dropdown-header text-center">
                          <strong class="text-center">{{'field.label.all_notification' | translate | async }}</strong>
                        </div>
                        <div [ngClass]="payload.length > 3 ? 'scroll-body-notification': 'scoll-heigth-notify'" scroll-directive
                          (onScroll)="onScrollList($event)">
                          @for (hasPayload of payload; track $index) {
                            <span class="dropdown-item">
                              <span style="white-space: initial;">{{hasPayload.payload.message}}</span><br>
                              <small>{{hasPayload.g_creation_time | dateTimeFormat}}</small><br>
                            </span>
                          }
                        </div>
                      </div>
                    }
                  </span>
                }
                <!-- {{payload.length | json}} -->
                @if (payload && showNotification) {
                  <span>
                    @if (payload.length == 0) {
                      <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg _menu-dropdown"
                        style="top: 40px; display:block">
                        <div class="dropdown-header text-center">
                          <strong class="text-center">{{'field.label.all_notification' | translate | async }}</strong>
                        </div>
                        <span class="dropdown-item"> {{'field.label.no_noification_for_this_user' | translate | async }}</span>
                      </div>
                    }
                  </span>
                }
              </div>
            </li>
          }
          @if (config.headerComponent.role_sel && _currentData.roleList && !_currentData.firstTimeLogin && !checkKioskUser()) {
            <li title="{{'Change Role' | translate | async }}" class="role-container _header-item">
              <div class="dropdown header-dropdown dd-hover _ha-icon" [triggered]="config.showRole" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false"
                (click)="config.showRole = !config.showRole; checkShowRole($event);" (clickOutside)="closeDropdownEvents()">
                <!-- <img src="assets/images/role-icon.png"> -->
                <img src="assets/images/role-icon.svg" class="_role-icon">
                <div class="_menu-dropdown dropdown-menu dropdown-menu-right dropdown-menu-sm" id="role-dropdown"
                  style="top: 40px;display:block;" [hidden]="config.showRole == undefined || !config.showRole">
                  <div class="dropdown-header">
                    <strong>{{'Role Management' | translate | async }}</strong>
                  </div>
                  <input type="text" [value]="filter" class="search form-control" id="complex-search-input"
                    autocomplete="off" [(ngModel)]="filterKey" [placeholder]="'field.label.search_role'| translate | async"
                    (keydown.enter)="handleKeyEnter($event)" (keydown)="onFilter($event)" (keyup)="onSearchKey($event);"
                    #input />
                  @for (role of _currentData.roleList ?? []; track $index) {
                    <a class="dropdown-item" (click)="sessionStoringForRole(role)"
                      [class.active]="role.role == _currentData.currentRole.role"
                      href="javascript:void(0);">{{role.role | translate | async}}</a>
                  }
                </div>
              </div>
            </li>
          }


          <li class="super-app-container _header-item">
            @if (config.showSuperApp) {
              <div id="super-app" class="dropdown header-dropdown dd-hover"
                data-toggle="dropdown" [triggered]="config.showSuperAppMenu" aria-haspopup="true" aria-expanded="false"
                (click)="config.showSuperAppMenu = !config.showSuperAppMenu;" (clickOutside)="closeDropdownEvents()">

                <div class="super-app-icon-container _ha-icon" title="Select Application">
                  <i class="fa fa-th" aria-hidden="true"></i>
                </div>
                <div id="super-app-m-body" class="_menu-dropdown dropdown-menu dropdown-menu-right dropdown-menu-sm"
                  style="top: 40px;display:block;"
                  [hidden]="config.showSuperAppMenu == undefined || !config.showSuperAppMenu">
                  <div class="dropdown-header">
                    <strong>Select Application</strong>
                  </div>
                  <dhs-domain-platform
                    [domainPlatformList]="appService._currentSessionData.superApps"></dhs-domain-platform>

                </div>
              </div>
            }
          </li>
          @if (appService.isWCAGEnabled()) {
            <li title="{{'Accessibility' | translate | async }}" class="_header-item">
              <div class="_voice-icon _ha-icon" (click)="tooglAccessibility()">
                <img class="img-avatar header-profile-icon" src="assets/images/accessibility.svg">
              </div>
            </li>
          }
        }
        <li title="" class="profileMenu show" #profileMenuRef>
          @if (speedConfig.data != undefined && speedConfig.data.speedType != undefined && speedConfig.data.speedType != 'high') {
            <div class="slow_speed" title="{{speedConfig.data.speedType}} Speed"></div>
          }
          <a [triggered]="config.showProfile" (click)="config.showProfile=true;" (clickOutside)="closeDropdownEvents()">
            @if (!profile_path) {
              <div class="cicurlar-name"
                [ngStyle]="{'background-color':_currentData.colorCoding,'border':'1px solid '+_currentData.colorCoding}">
                {{_currentData.loggedInInitial}}</div>
            }
            @if (profile_path) {
              <img class="img-avatar header-profile-icon" style="width: 36px;height: 36px;"
                [src]="profile_path" alt="">
            }
            <i aria-hidden="true" class="fa fa-angle-down"></i>
          </a>
          <div class="_menu-dropdown profile-menu-dropdown"
            [hidden]="config.showProfile == undefined || !config.showProfile">
            <!--Back button for mobile menu-->
            <div class="icons-for-back-cross">
              <div class="profile-menu-back-icon" (click)="config.showProfile = !config.showProfile">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
              </div>
            </div>
            <div class="profile-menu-container">
              <!--profile menu top section-->
              <div class="profile-dropdown-top">
                <div class="profile-top-container-left">
                  @if (!profile_path) {
                    <div class="cicurlar-name"
                      [ngStyle]="{'background-color':_currentData.colorCoding,'border':'1px solid '+_currentData.colorCoding}">
                      {{_currentData.loggedInInitial}}</div>
                  }
                  @if (profile_path) {
                    <img style="width: 36px;height: 36px;" [src]="profile_path">
                  }
                </div>
                @if (_currentData.currentUser) {
                  <div class="profile-top-container-right">
                    <div class="_uname">{{_currentData.loggedInUserName}}</div>
                    <div class="">{{_currentData.currentRole.role | translate | async}}</div>
                    <div class="">{{_currentData.currentUser.login_id}}</div>
                  </div>
                }
              </div>

              <!--profile middle section-->
              <div class="profile-menu-middle-section">
                <!-- for voice search Enable in system -->
                @if (utilService.isMobile()) {
                  <div class="mt-2">
                    <kx-voice-search></kx-voice-search>
                  </div>
                }
                <!--prime/general for mobile-->
                @if (config.headerComponent.care_type && _getmultiOpdConfig('multi_care_type') && _getmultiOpdConfig('care_type').length != 0 && currentResourecValue$ && utilService.isMobile()) {
                  <div class="mt-2">
                    <app-opd-type-selection [care_type]="_getmultiOpdConfig('care_type')"
                      [checkDisabled]="checkResourceDisbled$" (opdType)="changeopdType($event)">
                    </app-opd-type-selection>
                  </div>
                }
                <!--prime/general for mobile-->

                <!--Role Dropdown-->
                @if (config.headerComponent.role_sel && _currentData.roleList && _currentData.roleList.length != 1) {
                  <div data-toggle="collapse" class="kx-dropdown drop-downitem doctoricon role-dropdown "
                    (click)="showById('roles-dropdown')">
                    <img src="assets/images/mob-profile-role-coloured.svg">{{_currentData!=undefined &&
                    _currentData.currentRole!=undefined &&
                    _currentData.currentRole.role!=undefined&&_currentData.currentRole.role?_currentData.currentRole.role:'Select Role'}}
                  </div>
                }
                <div id="roles-dropdown" class="collapse profile-dropdowns">
                  <input type="text" [value]="filter" class="search form-control" id="complex-search-input"
                    autocomplete="off" [(ngModel)]="filterKey"
                    [placeholder]="'field.label.search_role'| translate | async" (keydown.enter)="handleKeyEnter($event)"
                    (keydown)="onFilter($event)" (keyup)="onSearchKey($event);" #input />
                  @for (role of _currentData.roleList ?? []; track $index) {
                    <p class="drop-downitem" (click)="sessionStoringForRole(role)"
                      [class.active]="role.role == _currentData.currentRole.role">
                      {{role.role}}</p>
                  }
                </div>
                <!--Role Dropdown-->

                <!--Facility Select Dropdown-->
                @if (config.headerComponent.facility_sel && _currentData.org && _currentData.org.org_name != undefined && !appService.isFacilityAware()) {
                  <div class="kx-dropdown">
                    <kx-multiselect-dropdown class="" tabindex="-1" [settings]="facilitySearchSelect.defaultsetting"
                      [questions]="facilitySearchSelect.question" [format]="facilitySearchSelect.question.format"
                      name="facility" [placeholder]="_currentData.org.org_name" [data]="facilitySearchSelect.datasource"
                      (onSelect)="onItemSelect($event)">
                    </kx-multiselect-dropdown>
                  </div>
                }
                <!--Facility Select Dropdown-->
                <!--Facility Location Dropdown-->
                <ng-template #locationRendrer let-appService='appService'>
                  @if (appService.getLocation() && appService._currentSessionData.jsonLocationAware) {
                    <div title="Store Location"
                      class="_header-item d-none d-lg-block dropdown store-location-selector header-dropdown dd-hover">
                      <a class="loc_dropdown" [triggered]="config.showLocation" role="button" id="dropdownMenuLink"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        (click)="toggleLocationDropdown()" (clickOutside)="closeDropdownEvents()">
                        <i class="fa fa-map-marker pr-1" aria-hidden="true"></i>
                        <span>{{(appService.getCurrentLocation())?appService.getCurrentLocation().location_name:getlocationText('Select Location')}}</span>
                        @if (appService.getCurrentLocation() && !appService.isLocationAware()) {
                          <i class="fa fa-times-circle loc_down_arrow pl-1" (click)="removeLocation()" aria-hidden="true"></i>
                        }
                        <i class="fa fa-angle-down loc_down_arrow pl-1" aria-hidden="true"></i>
                      </a>
                      <div class="dropdown-menu dropdown-menu-left dropdown-menu-lg _menu-dropdown" id="location-dropdown"
                        style="top: 36px;display:block;"
                        [hidden]="config.showLocation == undefined || !config.showLocation">
                        <div class="dropdown-header text-center"><strong _ngcontent-kav-c2="">{{'All Locations' | translate
                        | async}}</strong></div>

                        <input type="text" class="search form-control" id="location-search-input" autocomplete="off"
                          [(ngModel)]="storeSearchedInput" [placeholder]="'field.label.search_location' | translate | async"
                          (keyup)="onLocationSearch($event)" (click)="$event.stopPropagation()" (keydown.enter)="handleKeyEnter($event)"
                          (keydown)="onFilter($event)" />

                        @for (location of _currentData.locationList; track trackByLocationId($index, location)) {
                          <a class="dropdown-item" href="javascript:void(0);"
                            (click)="locationChange(location)">
                            <div class="message" style="display: flex;">
                              <div class="">{{location.location_name}}</div>
                            </div>
                          </a>
                        }

                        @if (_currentData.locationList.length === 0) {
                          <div class="dropdown-item text-center text-muted">
                            {{'field.label.no_records_found' | translate | async}}
                          </div>
                        }
                      </div>
                    </div>
                  }
                </ng-template>
                <!--Facility Location Dropdown-->

                <!--Store Location Dropdown-->
                @if (config.headerComponent.location_sel && storeAllowed) {
                  <ng-container>
                    @if (appService.getLocation()) {
                      <div data-toggle="collapse" class="kx-dropdown drop-downitem storeicon"
                        data-target="#store-dropdown" [disabled]="appService._currentSessionData.jsonLocationAware"
                        (click)="showById('store-dropdown'); initLocationList()"><img
                          src="assets/images/mob-store-icn.svg">{{(appService.getCurrentLocation())?appService.getCurrentLocation().location_name:'Select Location'}}
                      </div>
                    }
                    @if (appService._currentSessionData.jsonLocationAware) {
                      <div id="store-dropdown" class="collapse profile-dropdowns">
                        <input type="text" class="search form-control" id="location-search-mobile" autocomplete="off"
                          [(ngModel)]="storeSearchedInput" [placeholder]="'field.label.search_location' | translate | async"
                          (keyup)="onLocationSearch($event)" (click)="$event.stopPropagation()" (keydown.enter)="handleKeyEnter($event)"
                          (keydown)="onFilter($event)"/>

                        @for (location of _currentData.locationList; track trackByLocationId($index, location)) {
                          <p class="drop-downitem"
                            (click)="locationChange(location)">{{location.location_name}}</p>
                        }
                        @if (_currentData.locationList.length === 0) {
                          <p class="drop-downitem text-center text-muted">
                            {{'field.label.no_records_found' | translate | async}}
                          </p>
                        }
                      </div>
                    }
                  </ng-container>
                }
                <!--Store Location Dropdown-->

                <!-- <div class="_link"><a href="javascript:void(0);">Manage your account</a></div> -->
                @if (checkUserType() && !checkKioskUser()) {
                  <div class="drop-downitem" style="cursor: pointer;"
                    (click)="profileDetails()">
                    <i class="fa fa-address-card-o mr-2"></i> {{'button.view_profile' | translate | async}}
                  </div>
                }

                @if (this._currentData.currentUser && this._currentData.currentUser['user_type'] == 'patient' && !checkKioskUser() && !this._currentData.firstTimeLogin) {
                  <div class="drop-downitem" style="cursor: pointer;"
                    (click)="selectProfile()">
                    <!-- <i class="fa fa-users mr-2"></i> -->
                    <img class="svg-transparent" src="assets/images/switch-profile-v2.svg">
                    {{'button.manage_family' | translate | async}}
                  </div>
                }
                @if (this._currentData.currentUser && this._currentData.currentUser['user_type'] == 'patient' && !checkKioskUser() && !this._currentData.firstTimeLogin) {
                  <div class="drop-downitem" style="cursor: pointer;"
                    (click)="checkConsent()">
                    <img class="svg-transparent" src="assets/images/switch-profile-v2.svg">
                    {{'button.check_consent' | translate | async}}
                  </div>
                }
                @if (this._currentData.currentUser && this._currentData.currentUser['user_type'] == 'patient' && !checkKioskUser()) {
                  <div class="drop-downitem" style="cursor: pointer;"
                    (click)="setPrimary(_currentData)">
                    <img class="svg-transparent" src="assets/images/switch-profile-v2.svg">
                    {{'button.set_primary' | translate | async}}
                  </div>
                }
                @if (appService._currentSessionData.showAccountWebsite) {
                  <div title=" Website" class="drop-downitem"
                    style="cursor: pointer;">
                    <a class=" web_link_a" (click)="openWebsite()"
                      rel="noopener noreferrer">
                      <i aria-hidden="true" class="mr-2"><img src="assets/images/icons/web-link.svg" alt="" width="15px"
                          height="15px"></i>
                      {{appService._currentSessionData.accountWebsiteLabel}}
                    </a>
                  </div>
                }

                @if (config.headerComponent.change_loginid && roleService.checkAccessPermission('change_login','login','account-management')) {
                  <div class="drop-downitem"
                    style="cursor: pointer;" [routerLink]="['/change_loginId']">
                    <i class="fa fa-lock mr-2"></i>{{'button.change_login_id' | translate | async}}
                  </div>
                }
                @if (!checkKioskUser() && _currentData.currentRole['role'] != 'payment') {
                  <div class="drop-downitem" style="cursor: pointer;" (click)="changePass()">
                    <i class="fa fa-key mr-2"></i>{{'button.change_password' | translate | async}}
                  </div>
                }
                @if (config.headerComponent.gen_pin && this._currentData.currentUser && this._currentData.currentUser['user_type'] != 'patient' && this._currentData.currentRole['role_type'] !='Practitioner' && _currentData.currentRole['role'] != 'payment') {
                  <div class="drop-downitem"
                    style="cursor: pointer;" [routerLink]="['/manage_user_pin']">
                    <i class="fa fa-shield mr-2"></i>{{'button.manage_user_pin' | translate | async}}
                  </div>
                }
                @if (config.headerComponent.url_update && this._currentData.currentUser && this._currentData.currentUser['user_type'] != 'patient' && this._currentData.currentUser['user_type'] != 'system_user' && this._currentData.currentRole['role_group_scope'] != 'account'&& this._currentData.currentRole['role_type'] !='Practitioner') {
                  <div class="drop-downitem" style="cursor: pointer;" (click)="changeLandingUrl()">
                    <i class="fa fa-pencil-square-o mr-2"></i>{{'button.update_landing_url' | translate | async}}
                  </div>
                }
                @if (config.headerComponent.support && roleService.checkAccessPermission('support','login','account-management')) {
                  <div class="drop-downitem"
                    style="cursor: pointer;" [routerLink]="['/support']">
                    <i class="fa fa-headphones mr-2"></i>{{'button.support' | translate | async}}
                  </div>
                }
                <!-- <div class="drop-downitem" style="cursor: pointer;" *ngIf="!checkUserType()" (click)="viewTrainingVideos()">
              <i class="fa fa-video-camera" aria-hidden="true"></i>{{'pagename.list.training_videos' | translate | async}}
            </div> -->
                @if (config.headerComponent.def_faclity && roleService.checkAccessPermission('setDefaultFacility','userOrganization_mapping','account-management')) {
                  <div class="drop-downitem" style="cursor: pointer;"
                    (click)="setDefaultFacility()">
                    <i class="fa fa-building-o" aria-hidden="true"></i>{{'pagename.list.setDefaultFacility' | translate |
                    async}}
                  </div>
                }
                @if (config.headerComponent.internet_speed && this._currentData.currentUser && this._currentData.currentUser['user_type'] != 'patient' && (_currentData.currentRole && _currentData.currentRole.role_type != 'Practitioner')) {
                  <div class="drop-downitem" style="cursor: pointer;" (click)="openSpeedTest()">
                    <i class="fa fa-tachometer mr-2"></i>{{'button.check_my_internet_speed' | translate | async}}
                  </div>
                }
                @if (config.headerComponent.shortcut && this._currentData.currentUser && _currentData.currentUser['user_type'] != 'patient' &&
                  (_currentData.currentRole && _currentData.currentRole.role_type != 'Practitioner') && _currentData.currentRole['role'] != 'payment') {
                  <div class="drop-downitem" style="cursor: pointer;" (click)="openShortcuts()">
                    <i class="fa fa-desktop mr-2"></i>{{'button.check_screen_shortcuts' | translate | async}}
                  </div>
                }
                @if (rolePermissionService.checkAccessPermission('UPDATE_ACCOUNT_SETTINGS','user_preference','account-management')) {
                  <div class="drop-downitem" style="cursor: pointer;" (click)="configureHeader()">
                    <i class="fa fa-cog mr-2"></i>{{'chead' | translate | async}}
                  </div>
                }
                @if (appService._currentSessionData && appService._currentSessionData.showqrLogin) {
                  <div class="drop-downitem"
                    style="cursor: pointer;" (click)="showQRScanner()">
                    <i class="fa fa-cog mr-2"></i>{{'scnqr' | translate | async}}
                  </div>
                }


                @if (config.headerComponent.language_sel && appService._currentSessionData && appService._currentSessionData.languageList && appService._currentSessionData.languageList.length != 1) {
                  <div data-toggle="collapse"
                    class="kx-dropdown drop-downitem d-none languageicon" data-target="#language-dropdown"
                    (click)="showById('language-dropdown')"><img
                      src="assets/images/mob-profile-lang-coloured.svg">{{selectedLanguage!=undefined &&
                    selectedLanguage?selectedLanguage:'Select language'}}
                  </div>
                }
                <div id="language-dropdown" class="collapse profile-dropdowns">
                  @for (language of appService._currentSessionData.languageList ?? []; track $index) {
                    <p class="language drop-downitem"
                      [value]="language.languageCode" (click)="languageChange(language.languageCode)">
                      {{language.languageName}}</p>
                  }
                  <!--  <p class="language drop-downitem" >German</p>
              <p class="language drop-downitem" >Japanese</p>-->
                </div>

                <!-- <div data-toggle="collapse" class="kx-dropdown drop-downitem facilityicon"
              *ngIf="_currentData.organizations.length>0" data-target="#facility-dropdown"
              (click)="showById('facility-dropdown')"><img
                src="assets/images/mob-profile-location.svg">{{_currentData!=undefined && _currentData.org!=undefined && _currentData.org.org_name!=undefined && _currentData.org.org_name?_currentData.org.org_name:'Select Facility'}}
            </div>
            <div id="facility-dropdown" class="collapse profile-dropdowns">
              <p class="drop-downitem" *ngFor="let organization of _currentData.organizations; let i=index"
                (click)="OrganizationChange(organization.org_id)">{{organization.org_name}}</p>
            </div> -->

                @if (config.headerComponent.ai_agent_dashboard) {
                  <div title=" Ai Agent App Store"
                    class="drop-downitem d-block d-lg-none" style="cursor: pointer;">
                    <a class=" web_link_a d-flex align-items-center" (click)="naviagteToLink('/emr/ai-agent-dashboards')" rel="noopener noreferrer">
                      <i aria-hidden="true" class="mr-2 notification-icon-container ai-icon-container "><img src="/assets/images/ai-icon-star.svg" alt="" width="27px" height="27px"></i>
                      {{'link.ai_agent_dashboard'| translate | async}}
                    </a>
                  </div>
                }
                @if (config.headerComponent.install_app && showInstallBtn) {
                  <div class="drop-downitem" (click)="installApp()" style="cursor: pointer;"><i class="fa fa-mobile mr-2"></i>{{'button.install_app'
                    | translate | async}}
                  </div>
                }

              </div>

              <!--profile menu footer section-->
              <div class="profile-menu-footer-section">
                <div class="drop-downitem" (click)="logout()" style="cursor: pointer;">
                  <i class="fa fa-sign-out mr-2"></i>{{'button.logout' | translate | async}}
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    }
  </app-header>
  <div id="core-body" class="app-body"
    [ngClass]="{'mobile-footer-menu':appService._currentSessionData.mobileMenu != undefined && appService._currentSessionData.mobileMenu.length,
'secondary_nav':appService._currentSessionData.hideMenuIcon,'fixed-banner':appService._currentSessionData['fixed_banner'], 'app-telemedicine-minimized-container': checktelemedicine(),'mobile-pagination':checkPagination()}">
    @if (!isAndroid) {
      <app-sidebar [fixed]="true" [display]="'lg'" [triggered]="appService.showSidebar"
        [minimized]="minimized" #sidebar (minimizedChange)="toggleMinimize($event)" (clickOutside)="toggler($event)">
        <app-sidebar-nav [navItems]="appService._currentSessionData.sidebarJson" [perfectScrollbar]
          [disabled]="sidebar.minimized"></app-sidebar-nav>
        @if (rolePermissionService.checkAccessPermission('UPDATE_ACCOUNT_SETTINGS','user_preference','account-management')) {
          <span
            class="configure_menu" (click)="configureMenu()">
            <i title="{{'cm' | translate | async}}" class="fa fa-cog"></i>
          </span>
        }
        <app-sidebar-minimizer></app-sidebar-minimizer>
      </app-sidebar>
    }
    @if (isAndroid) {
      <app-sidebar [fixed]="true" [display]="'lg'" [triggered]="appService.showSidebar"
        [minimized]="minimized" #sidebar (minimizedChange)="toggleMinimize($event)" (clickOutside)="toggler($event)">
        <app-sidebar-nav [navItems]="appService._currentSessionData.sidebarJson" [disabled]="sidebar.minimized">
        </app-sidebar-nav>
        <app-sidebar-minimizer></app-sidebar-minimizer>
      </app-sidebar>
    }
    <!-- Main content -->
    <main class="main" [ngClass]="checktelemedicine()" style="min-height: 85vh;">
      <!-- <div class="progress-wrapper">
      <div class="progress-container">
        <div class="progress-bar" id="kx-prog-bar"></div>
      </div>
    </div> -->
      <!-- Breadcrumb -->
      <!-- <dhs-app-breadcrumbs [breadcrumbs]="breadcrumbs"></dhs-app-breadcrumbs> -->
      <div class="kx-content-container container-fluid box-layout base-box-layout scrollertransparent"
        [ngClass]="componentClass">
        <router-outlet></router-outlet>
        @if (appService._currentSessionData.mobileMenu != undefined && appService._currentSessionData.mobileMenu.length) {
          <div class="_wf-ps-bootomfotter" id="mobile-quick-action-nav">
            @for (mobileMenu of appService._currentSessionData.mobileMenu ?? []; track $index) {
              <div [routerLink]="[mobileMenu.url]" [class.active]="router.isActive(mobileMenu.url,false)"
                class="_wf-ps-home">
                <div class="mobilemenu_icon">
                  <img
                    src="assets/images/mobile-menu/{{router.isActive(mobileMenu.url,false)?mobileMenu.image_url+'-active':mobileMenu.image_url}}.svg">
                </div>
                <div>{{mobileMenu.mobileMenuName | translate | async}}</div>
              </div>
            }
          </div>
        }
      </div>
    </main>
    <app-aside [fixed]="true" [display]="false" style="margin-right: 0px!important;" id="aside-modal-container"
      class="d-none">
    </app-aside>
  </div>

  <ng-template #locationRendrer let-appService='appService'>
    <!---- Store LOCATION DROPDOWN ---->
    @if (appService.getLocation() && appService._currentSessionData.jsonLocationAware) {
      <div class="d-none d-lg-block dropdown store-location-selector header-dropdown ml-3 mr-3 dd-hover">
        <a class="loc_dropdown" [triggered]="config.showLocation" role="button" id="dropdownMenuLink"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
          (click)="config.showLocation = !config.showLocation;" (clickOutside)="closeDropdownEvents()">
          <i class="fa fa-map-marker pr-1" aria-hidden="true"></i>
          <span>{{(appService.getCurrentLocation())?appService.getCurrentLocation().location_name:getlocationText('Select Location')}}</span>
          @if (appService.getCurrentLocation() && !appService.isLocationAware()) {
            <i class="fa fa-times-circle loc_down_arrow pl-1" (click)="removeLocation()" aria-hidden="true"></i>
          }
          <i class="fa fa-angle-down loc_down_arrow pl-1" aria-hidden="true"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-left dropdown-menu-lg" id="location-dropdown"
          style="top: 36px;display:block;" [hidden]="config.showLocation == undefined || !config.showLocation">
          <div class="dropdown-header text-center"><strong _ngcontent-kav-c2="">All
              Locations</strong></div>
          @for (location of appService.getLocation() ?? []; track $index) {
            <a class="dropdown-item" href="javascript:void(0);"
              (click)="locationChange(location)">
              <div class="message" style="display: flex;">
                <div class="">{{location.location_name}}</div>
              </div>
            </a>
          }
        </div>
      </div>
    }
    <!---- LOCATION DROPDOWN ---->
  </ng-template>

  <ng-template #tokenRendrer let-appService='appService'>
    <kx-token></kx-token>
  </ng-template>

  <app-footer>
    <span><a href="https://www.karexpert.com">KareXpert</a> &copy; {{getCurrentYear()}}.</span>
    <span class="ml-auto">Powered by <a href="https://www.karexpert.com">KareXpert Technologies Pvt. Ltd.</a></span>
  </app-footer>
}
